export const getAddNewQuestionObj = () => {
  return {
    // EmployeeDetails
    id: "",
    questionCategoriesId: "",
    questionTypesId: "",
    question: "",
    //   options: "",
    attachment: "",
    answer: "",
    Status: "",
    option1: "",
    option2: "",
    option3: "",
    option4: "",
  };
};
